
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/services/ServiceDetailPage'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));

const WhyUsPage = lazy(() => import('../pages/why-us/page'));
const PrivacyPage = lazy(() => import('../pages/legal/PrivacyPage'));
const TermsPage = lazy(() => import('../pages/legal/TermsPage'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news/NewsDetailPage'));

const AdminPage = lazy(() => import('../pages/admin/page'));
const LoginPage = lazy(() => import('../pages/admin/LoginPage'));
const ProtectedRoute = lazy(() => import('../components/auth/ProtectedRoute'));

const CRMPage = lazy(() => import('../pages/crm/page'));
const WebmailPage = lazy(() => import('../pages/webmail/page'));
const PartnershipPage = lazy(() => import('../pages/partnership/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Dedicated Service Landing Pages
const LogisticsPage = lazy(() => import('../pages/services/LogisticsPage'));
const InspectionPage = lazy(() => import('../pages/services/InspectionPage'));
const CertificatesPage = lazy(() => import('../pages/services/CertificatesPage'));
const InsurancePage = lazy(() => import('../pages/services/InsurancePage'));
const WorkPermitsPage = lazy(() => import('../pages/services/WorkPermitsPage'));
const HealthcarePage = lazy(() => import('../pages/services/HealthcarePage'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  // Dedicated Service Landing Pages
  {
    path: '/services/logistics-solutions',
    element: <LogisticsPage />,
  },
  {
    path: '/services/goods-inspection-certification',
    element: <InspectionPage />,
  },
  {
    path: '/services/trade-statutory-certificates',
    element: <CertificatesPage />,
  },
  {
    path: '/services/insurance-services',
    element: <InsurancePage />,
  },
  {
    path: '/services/work-permits-foreigners',
    element: <WorkPermitsPage />,
  },
  {
    path: '/services/healthcare-services',
    element: <HealthcarePage />,
  },
  // Generic service detail page (fallback)
  {
    path: '/services/:slug',
    element: <ServiceDetailPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/partnership',
    element: <PartnershipPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },

  {
    path: '/why-us',
    element: <WhyUsPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/crm',
    element: <CRMPage />,
  },
  {
    path: '/admin/login',
    element: <LoginPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/admin',
        element: <AdminPage />,
      },
    ]
  },
  {
    path: '/webmail',
    element: <WebmailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;



